/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React from 'react';
import { ExtensionStatus } from '../../utils/constants';
import { Action } from './actions';

export type State = {
	status: ExtensionStatus;
	minVersion?: string;
	installedVersion?: string;
	useBeta?: boolean;
	useDev?: boolean;
};

type ExtensionContext = {
	state: State;
	dispatch: React.Dispatch<Action>;
};

const defaultValues = {
	state: {
		status: ExtensionStatus.Pending,
	},
	dispatch: () => null,
};

const WebExtensionContext = React.createContext<ExtensionContext>(defaultValues);

export default WebExtensionContext;
